export default __webpack_public_path__ + "static/media/LAS0140.34I-30448_-17556_0.4f75f52c.jpg";